import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-50 border-t border-background-300/30">
      <div className="max-w-screen-xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          {/* Subscribe */}
          <div className="md:col-span-5">
            <h3 className="font-heading text-3xl font-light text-foreground-50 tracking-wide mb-3">
              订阅更新
            </h3>
            <p className="text-sm text-foreground-400 mb-8 leading-relaxed">
              第一时间获取最新韩漫上架信息和阅读推荐
            </p>
            <div className="flex flex-col sm:flex-row gap-0 max-w-md">
              <input
                type="email"
                placeholder="输入您的邮箱"
                className="flex-1 bg-transparent border-b border-foreground-700/50 py-3 px-0 text-sm text-foreground-200 placeholder-foreground-600 focus:outline-none focus:border-primary-500 transition-colors"
              />
              <button className="mt-3 sm:mt-0 sm:ml-4 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap flex items-center gap-2 cursor-pointer">
                订阅
                <i className="ri-arrow-right-up-line text-sm"></i>
              </button>
            </div>
          </div>

          {/* Navigation */}
          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-foreground-200 mb-5 uppercase tracking-wider">
              快速导航
            </h4>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-sm text-foreground-400 hover:text-foreground-50 transition-colors underline decoration-foreground-700/30 underline-offset-4 whitespace-nowrap">
                首页
              </Link>
              <Link to="/category/action" className="text-sm text-foreground-400 hover:text-foreground-50 transition-colors underline decoration-foreground-700/30 underline-offset-4 whitespace-nowrap">
                分类浏览
              </Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-foreground-50 transition-colors underline decoration-foreground-700/30 underline-offset-4 whitespace-nowrap">
                关于我们
              </Link>
              <Link to="/help" className="text-sm text-foreground-400 hover:text-foreground-50 transition-colors underline decoration-foreground-700/30 underline-offset-4 whitespace-nowrap">
                帮助中心
              </Link>
            </div>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <h4 className="text-sm font-semibold text-foreground-200 mb-5 uppercase tracking-wider">
              联系我们
            </h4>
            <div className="space-y-2 mb-6">
              <p className="text-sm text-foreground-400">
                <span className="text-foreground-500">客服电话：</span>400-888-6666
              </p>
              <p className="text-sm text-foreground-400">
                <span className="text-foreground-500">电子邮箱：</span>hello@zzxcdell.com
              </p>
            </div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-3 uppercase tracking-wider">
              公司地址
            </h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              上海市浦东新区张江高科技园区<br />
              博云路2号浦软大厦18层
            </p>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-background-300/30">
        <div className="max-w-screen-xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-6">
            <a href="#" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors underline decoration-foreground-700/30 underline-offset-4" rel="nofollow">
              微博
            </a>
            <a href="#" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors underline decoration-foreground-700/30 underline-offset-4" rel="nofollow">
              微信
            </a>
            <a href="#" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors underline decoration-foreground-700/30 underline-offset-4" rel="nofollow">
              B站
            </a>
          </div>
          <p className="text-xs text-foreground-600 whitespace-nowrap">
            &copy; 2026 韩漫画网 版权所有
          </p>
          <div className="flex items-center gap-5">
            <Link to="/privacy" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors underline decoration-foreground-700/30 underline-offset-4 whitespace-nowrap">
              隐私政策
            </Link>
            <Link to="/terms" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors underline decoration-foreground-700/30 underline-offset-4 whitespace-nowrap">
              服务条款
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}